import { render, staticRenderFns } from "./ViewImageButton.vue?vue&type=template&id=3cd1889d&"
import script from "./ViewImageButton.vue?vue&type=script&lang=js&"
export * from "./ViewImageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports